module.exports = __webpack_public_path__ + "static/media/together-logo-client-page-01.f31636d4.png";